import React from 'react';
import invisionBanner from '../../images/invisionBanner.png';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Sonido from '../../components/Sonido';
import Somos from '../../components/Somos';
import Beneficios from '../../components/Beneficios';
import Testimonios from '../../components/Testimonios';

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div
        className="bg-blue-900 text-white flex flex-col items-center"
        style={{
          backgroundImage: `url(${invisionBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Header />
        <Sonido />
      </div>

      <div className="flex-grow bg-[#0f172a]">
        <Somos />
        <Beneficios />
        <Testimonios />
      </div>
        <Footer />

    </div>
  );
};

export default Home;